module.exports = __webpack_public_path__ + "static/media/forEdInst.0ad971ad.webp";